'use client';

import Image from 'next/image';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ButtonIcon({
  url,
  alt,
  className,
  prioritize = false,
}: {
  url: string;
  alt: string;
  className?: string;
  prioritize?: boolean;
}) {
  const isSvg = url.split('?')[0].endsWith('.svg');

  return (
    <Image
      src={url}
      alt={alt}
      width={16}
      height={16}
      className={cn('max-h-5 min-h-5 min-w-5 max-w-5', className)}
      aria-hidden
      priority={prioritize}
      loading={prioritize ? 'eager' : 'lazy'}
      unoptimized={isSvg}
    />
  );
}
